@file:OptIn(InternalResourceApi::class)

package dev.jfronny.zerointerest.shared.generated.resources

import kotlin.OptIn
import kotlin.String
import kotlin.collections.MutableMap
import org.jetbrains.compose.resources.InternalResourceApi
import org.jetbrains.compose.resources.LanguageQualifier
import org.jetbrains.compose.resources.ResourceContentHash
import org.jetbrains.compose.resources.ResourceItem
import org.jetbrains.compose.resources.StringResource

private const val MD: String =
    "composeResources/dev.jfronny.zerointerest.shared.generated.resources/"

@delegate:ResourceContentHash(-1_302_511_237)
internal val Res.string.accept: StringResource by lazy {
      StringResource("string:accept", "accept", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 53, 30),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 45, 22),
      ))
    }

@delegate:ResourceContentHash(-1_944_984_160)
internal val Res.string.accept_all: StringResource by lazy {
      StringResource("string:accept_all", "accept_all", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 10, 42),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 10, 34),
      ))
    }

@delegate:ResourceContentHash(-472_562_432)
internal val Res.string.access_token: StringResource by lazy {
      StringResource("string:access_token", "access_token", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 84, 40),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 68, 36),
      ))
    }

@delegate:ResourceContentHash(1_425_134_543)
internal val Res.string.add_topic: StringResource by lazy {
      StringResource("string:add_topic", "add_topic", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 125, 41),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 105, 33),
      ))
    }

@delegate:ResourceContentHash(-1_303_785_148)
internal val Res.string.add_transaction: StringResource by lazy {
      StringResource("string:add_transaction", "add_transaction", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 167, 55),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 139, 43),
      ))
    }

@delegate:ResourceContentHash(1_949_686_577)
internal val Res.string.amount: StringResource by lazy {
      StringResource("string:amount", "amount", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 223, 22),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 183, 22),
      ))
    }

@delegate:ResourceContentHash(-1_741_469_186)
internal val Res.string.another_device_accepted_verification: StringResource by lazy {
      StringResource("string:another_device_accepted_verification", "another_device_accepted_verification", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 246, 124),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 206, 116),
      ))
    }

@delegate:ResourceContentHash(1_345_329_482)
internal val Res.string.another_device_requesting_verification: StringResource by lazy {
      StringResource("string:another_device_requesting_verification", "another_device_requesting_verification", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 371, 114),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 323, 102),
      ))
    }

@delegate:ResourceContentHash(-143_994_560)
internal val Res.string.app_name: StringResource by lazy {
      StringResource("string:app_name", "app_name", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 486, 32),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 426, 32),
      ))
    }

@delegate:ResourceContentHash(-1_678_132_896)
internal val Res.string.avatar: StringResource by lazy {
      StringResource("string:avatar", "avatar", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 519, 22),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 459, 22),
      ))
    }

@delegate:ResourceContentHash(2_108_665_268)
internal val Res.string.back: StringResource by lazy {
      StringResource("string:back", "back", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 542, 24),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 482, 20),
      ))
    }

@delegate:ResourceContentHash(2_019_214_900)
internal val Res.string.balances: StringResource by lazy {
      StringResource("string:balances", "balances", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 567, 24),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 503, 28),
      ))
    }

@delegate:ResourceContentHash(324_824_862)
internal val Res.string.cancel: StringResource by lazy {
      StringResource("string:cancel", "cancel", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 625, 26),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 561, 22),
      ))
    }

@delegate:ResourceContentHash(324_824_862)
internal val Res.string.cancel_topic: StringResource by lazy {
      StringResource("string:cancel_topic", "cancel_topic", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 592, 32),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 532, 28),
      ))
    }

@delegate:ResourceContentHash(-1_309_155_218)
internal val Res.string.choose_sso_provider: StringResource by lazy {
      StringResource("string:choose_sso_provider", "choose_sso_provider", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 652, 67),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 584, 63),
      ))
    }

@delegate:ResourceContentHash(1_478_976_734)
internal val Res.string.choose_verification_method: StringResource by lazy {
      StringResource("string:choose_verification_method", "choose_verification_method", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 720, 74),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 648, 70),
      ))
    }

@delegate:ResourceContentHash(339_411_655)
internal val Res.string.compare: StringResource by lazy {
      StringResource("string:compare", "compare", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 906, 31),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 826, 27),
      ))
    }

@delegate:ResourceContentHash(1_946_711_316)
internal val Res.string.compare_emoji_sequence: StringResource by lazy {
      StringResource("string:compare_emoji_sequence", "compare_emoji_sequence", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 795, 110),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 719, 106),
      ))
    }

@delegate:ResourceContentHash(790_306_780)
internal val Res.string.confirm: StringResource by lazy {
      StringResource("string:confirm", "confirm", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 1073, 31),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 961, 27),
      ))
    }

@delegate:ResourceContentHash(-442_900_945)
internal val Res.string.confirm_settle_all: StringResource by lazy {
      StringResource("string:confirm_settle_all", "confirm_settle_all", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 938, 134),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 854, 106),
      ))
    }

@delegate:ResourceContentHash(1_296_926_472)
internal val Res.string.continue_button: StringResource by lazy {
      StringResource("string:continue_button", "continue_button", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 1105, 31),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 989, 35),
      ))
    }

@delegate:ResourceContentHash(-1_587_243_832)
internal val Res.string.debug_hints: StringResource by lazy {
      StringResource("string:debug_hints", "debug_hints", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 1265, 39),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 1093, 35),
      ))
    }

@delegate:ResourceContentHash(-715_967_751)
internal val Res.string.debug_hints_description: StringResource by lazy {
      StringResource("string:debug_hints_description", "debug_hints_description", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 1137, 127),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 1025, 67),
      ))
    }

@delegate:ResourceContentHash(905_197_092)
internal val Res.string.debug_new_summary: StringResource by lazy {
      StringResource("string:debug_new_summary", "debug_new_summary", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 1305, 53),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 1129, 41),
      ))
    }

@delegate:ResourceContentHash(-1_035_044_457)
internal val Res.string.debug_reset_trust: StringResource by lazy {
      StringResource("string:debug_reset_trust", "debug_reset_trust", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 1359, 57),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 1171, 41),
      ))
    }

@delegate:ResourceContentHash(-99_019_889)
internal val Res.string.decline: StringResource by lazy {
      StringResource("string:decline", "decline", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 1417, 27),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 1213, 27),
      ))
    }

@delegate:ResourceContentHash(-345_869)
internal val Res.string.delete_template: StringResource by lazy {
      StringResource("string:delete_template", "delete_template", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 1445, 47),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 1241, 43),
      ))
    }

@delegate:ResourceContentHash(1_674_283_973)
internal val Res.string.description: StringResource by lazy {
      StringResource("string:description", "description", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 1493, 35),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 1285, 35),
      ))
    }

@delegate:ResourceContentHash(561_386_977)
internal val Res.string.deselect: StringResource by lazy {
      StringResource("string:deselect", "deselect", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 1529, 28),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 1321, 28),
      ))
    }

@delegate:ResourceContentHash(634_170_281)
internal val Res.string.device_offline: StringResource by lazy {
      StringResource("string:device_offline", "device_offline", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 1558, 46),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 1350, 46),
      ))
    }

@delegate:ResourceContentHash(1_218_640_023)
internal val Res.string.device_verified_successfully: StringResource by lazy {
      StringResource("string:device_verified_successfully", "device_verified_successfully", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 1605, 92),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 1397, 96),
      ))
    }

@delegate:ResourceContentHash(-1_992_909_899)
internal val Res.string.entered_by: StringResource by lazy {
      StringResource("string:entered_by", "entered_by", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 1698, 38),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 1494, 34),
      ))
    }

@delegate:ResourceContentHash(997_581_278)
internal val Res.string.error: StringResource by lazy {
      StringResource("string:error", "error", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 1737, 21),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 1529, 21),
      ))
    }

@delegate:ResourceContentHash(-117_180_936)
internal val Res.string.failed_create_trust_summary: StringResource by lazy {
      StringResource("string:failed_create_trust_summary", "failed_create_trust_summary", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 1759, 115),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 1551, 83),
      ))
    }

@delegate:ResourceContentHash(-1_462_167_995)
internal val Res.string.failed_prepare_trust_summary: StringResource by lazy {
      StringResource("string:failed_prepare_trust_summary", "failed_prepare_trust_summary", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 1875, 120),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 1635, 88),
      ))
    }

@delegate:ResourceContentHash(2_094_787_922)
internal val Res.string.failed_send_message: StringResource by lazy {
      StringResource("string:failed_send_message", "failed_send_message", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 2095, 79),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 1803, 59),
      ))
    }

@delegate:ResourceContentHash(471_497_677)
internal val Res.string.failed_send_message_with_error: StringResource by lazy {
      StringResource("string:failed_send_message_with_error", "failed_send_message_with_error", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 1996, 98),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 1724, 78),
      ))
    }

@delegate:ResourceContentHash(222_335_182)
internal val Res.string.favorite: StringResource by lazy {
      StringResource("string:favorite", "favorite", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 2247, 28),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 1927, 28),
      ))
    }

@delegate:ResourceContentHash(2_064_355_916)
internal val Res.string.favorite_room: StringResource by lazy {
      StringResource("string:favorite_room", "favorite_room", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 2175, 41),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 1863, 33),
      ))
    }

@delegate:ResourceContentHash(222_539_781)
internal val Res.string.favorites: StringResource by lazy {
      StringResource("string:favorites", "favorites", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 2217, 29),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 1897, 29),
      ))
    }

@delegate:ResourceContentHash(500_505_444)
internal val Res.string.flip_balances: StringResource by lazy {
      StringResource("string:flip_balances", "flip_balances", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 2362, 49),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 2038, 41),
      ))
    }

@delegate:ResourceContentHash(-1_058_612_252)
internal val Res.string.flip_balances_description: StringResource by lazy {
      StringResource("string:flip_balances_description", "flip_balances_description", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 2276, 85),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 1956, 81),
      ))
    }

@delegate:ResourceContentHash(-1_988_129_274)
internal val Res.string.follow_instructions_other_device: StringResource by lazy {
      StringResource("string:follow_instructions_other_device", "follow_instructions_other_device", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 2412, 112),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 2080, 112),
      ))
    }

@delegate:ResourceContentHash(706_681_967)
internal val Res.string.homeserver_url: StringResource by lazy {
      StringResource("string:homeserver_url", "homeserver_url", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 2525, 42),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 2193, 42),
      ))
    }

@delegate:ResourceContentHash(-1_212_963_763)
internal val Res.string.invalid_amount: StringResource by lazy {
      StringResource("string:invalid_amount", "invalid_amount", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 2568, 46),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 2236, 42),
      ))
    }

@delegate:ResourceContentHash(-1_842_070_899)
internal val Res.string.latest_summary_not_trusted: StringResource by lazy {
      StringResource("string:latest_summary_not_trusted", "latest_summary_not_trusted", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 2615, 98),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 2279, 70),
      ))
    }

@delegate:ResourceContentHash(-1_358_444_469)
internal val Res.string.lender: StringResource by lazy {
      StringResource("string:lender", "lender", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 2714, 30),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 2350, 22),
      ))
    }

@delegate:ResourceContentHash(-1_209_689_716)
internal val Res.string.login: StringResource by lazy {
      StringResource("string:login", "login", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 2845, 25),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 2453, 21),
      ))
    }

@delegate:ResourceContentHash(402_646_676)
internal val Res.string.login_failed: StringResource by lazy {
      StringResource("string:login_failed", "login_failed", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 2745, 52),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 2373, 36),
      ))
    }

@delegate:ResourceContentHash(-142_776_680)
internal val Res.string.login_with_sso: StringResource by lazy {
      StringResource("string:login_with_sso", "login_with_sso", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 2798, 46),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 2410, 42),
      ))
    }

@delegate:ResourceContentHash(-290_966_355)
internal val Res.string.logout: StringResource by lazy {
      StringResource("string:logout", "logout", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 2871, 26),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 2475, 22),
      ))
    }

@delegate:ResourceContentHash(-612_503_915)
internal val Res.string.match: StringResource by lazy {
      StringResource("string:match", "match", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 2898, 37),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 2498, 21),
      ))
    }

@delegate:ResourceContentHash(964_127_938)
internal val Res.string.mismatch: StringResource by lazy {
      StringResource("string:mismatch", "mismatch", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 2936, 48),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 2520, 28),
      ))
    }

@delegate:ResourceContentHash(-806_498_997)
internal val Res.string.monetary_unit_warning: StringResource by lazy {
      StringResource("string:monetary_unit_warning", "monetary_unit_warning", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 2985, 145),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 2549, 121),
      ))
    }

@delegate:ResourceContentHash(48_863_952)
internal val Res.string.more_options: StringResource by lazy {
      StringResource("string:more_options", "more_options", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 3131, 44),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 2671, 36),
      ))
    }

@delegate:ResourceContentHash(322_149_737)
internal val Res.string.new_transaction: StringResource by lazy {
      StringResource("string:new_transaction", "new_transaction", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 3176, 47),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 2708, 43),
      ))
    }

@delegate:ResourceContentHash(1_562_416_956)
internal val Res.string.no_balances_yet: StringResource by lazy {
      StringResource("string:no_balances_yet", "no_balances_yet", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 3224, 47),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 2752, 43),
      ))
    }

@delegate:ResourceContentHash(-446_741_292)
internal val Res.string.no_debts: StringResource by lazy {
      StringResource("string:no_debts", "no_debts", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 3272, 56),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 2796, 44),
      ))
    }

@delegate:ResourceContentHash(1_691_779_638)
internal val Res.string.no_rooms_available: StringResource by lazy {
      StringResource("string:no_rooms_available", "no_rooms_available", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 3329, 58),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 2841, 50),
      ))
    }

@delegate:ResourceContentHash(-499_641_024)
internal val Res.string.no_transactions_yet: StringResource by lazy {
      StringResource("string:no_transactions_yet", "no_transactions_yet", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 3388, 59),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 2892, 55),
      ))
    }

@delegate:ResourceContentHash(957_396_024)
internal val Res.string.not_included_in_summary: StringResource by lazy {
      StringResource("string:not_included_in_summary", "not_included_in_summary", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 3448, 91),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 2948, 75),
      ))
    }

@delegate:ResourceContentHash(81_670_336)
internal val Res.string.ok: StringResource by lazy {
      StringResource("string:ok", "ok", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 3540, 14),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 3024, 14),
      ))
    }

@delegate:ResourceContentHash(995_081_168)
internal val Res.string.`override`: StringResource by lazy {
      StringResource("string:override", "override", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 3555, 36),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 3039, 28),
      ))
    }

@delegate:ResourceContentHash(-1_410_167_777)
internal val Res.string.password: StringResource by lazy {
      StringResource("string:password", "password", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 3627, 28),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 3103, 28),
      ))
    }

@delegate:ResourceContentHash(-1_410_167_777)
internal val Res.string.password_login: StringResource by lazy {
      StringResource("string:password_login", "password_login", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 3592, 34),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 3068, 34),
      ))
    }

@delegate:ResourceContentHash(850_887_761)
internal val Res.string.payment: StringResource by lazy {
      StringResource("string:payment", "payment", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 3656, 27),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 3132, 27),
      ))
    }

@delegate:ResourceContentHash(-149_158_623)
internal val Res.string.pick_a_room: StringResource by lazy {
      StringResource("string:pick_a_room", "pick_a_room", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 3684, 39),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 3160, 35),
      ))
    }

@delegate:ResourceContentHash(171_748_166)
internal val Res.string.recipients: StringResource by lazy {
      StringResource("string:recipients", "recipients", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 3724, 34),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 3196, 34),
      ))
    }

@delegate:ResourceContentHash(559_617_406)
internal val Res.string.request_full_keyboard: StringResource by lazy {
      StringResource("string:request_full_keyboard", "request_full_keyboard", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 3893, 73),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 3353, 57),
      ))
    }

@delegate:ResourceContentHash(-1_497_726_582)
internal val Res.string.request_full_keyboard_description: StringResource by lazy {
      StringResource("string:request_full_keyboard_description", "request_full_keyboard_description", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 3759, 133),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 3231, 121),
      ))
    }

@delegate:ResourceContentHash(-1_317_973_006)
internal val Res.string.room: StringResource by lazy {
      StringResource("string:room", "room", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 4288, 20),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 3712, 20),
      ))
    }

@delegate:ResourceContentHash(1_909_117_764)
internal val Res.string.room_currency: StringResource by lazy {
      StringResource("string:room_currency", "room_currency", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 3967, 37),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 3411, 41),
      ))
    }

@delegate:ResourceContentHash(333_094_337)
internal val Res.string.room_info: StringResource by lazy {
      StringResource("string:room_info", "room_info", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 4005, 29),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 3453, 29),
      ))
    }

@delegate:ResourceContentHash(-1_237_843_685)
internal val Res.string.room_protocol_too_new: StringResource by lazy {
      StringResource("string:room_protocol_too_new", "room_protocol_too_new", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 4035, 225),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 3483, 201),
      ))
    }

@delegate:ResourceContentHash(-749_741_517)
internal val Res.string.room_topic: StringResource by lazy {
      StringResource("string:room_topic", "room_topic", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 4261, 26),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 3685, 26),
      ))
    }

@delegate:ResourceContentHash(-720_238_600)
internal val Res.string.save: StringResource by lazy {
      StringResource("string:save", "save", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 4393, 24),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 3809, 20),
      ))
    }

@delegate:ResourceContentHash(1_449_621_910)
internal val Res.string.save_as_template: StringResource by lazy {
      StringResource("string:save_as_template", "save_as_template", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 4309, 52),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 3733, 48),
      ))
    }

@delegate:ResourceContentHash(-720_238_600)
internal val Res.string.save_topic: StringResource by lazy {
      StringResource("string:save_topic", "save_topic", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 4362, 30),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 3782, 26),
      ))
    }

@delegate:ResourceContentHash(274_632_750)
internal val Res.string.select_all: StringResource by lazy {
      StringResource("string:select_all", "select_all", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 4418, 38),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 3830, 34),
      ))
    }

@delegate:ResourceContentHash(-117_383_833)
internal val Res.string.select_homeserver: StringResource by lazy {
      StringResource("string:select_homeserver", "select_homeserver", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 4457, 53),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 3865, 49),
      ))
    }

@delegate:ResourceContentHash(1_888_768_318)
internal val Res.string.settings: StringResource by lazy {
      StringResource("string:settings", "settings", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 4511, 36),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 3915, 28),
      ))
    }

@delegate:ResourceContentHash(1_999_950_319)
internal val Res.string.settle_up: StringResource by lazy {
      StringResource("string:settle_up", "settle_up", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 4603, 29),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 3991, 29),
      ))
    }

@delegate:ResourceContentHash(-1_741_311_789)
internal val Res.string.settle_up_desc: StringResource by lazy {
      StringResource("string:settle_up_desc", "settle_up_desc", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 4548, 54),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 3944, 46),
      ))
    }

@delegate:ResourceContentHash(-904_761_542)
internal val Res.string.source_code: StringResource by lazy {
      StringResource("string:source_code", "source_code", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 4633, 31),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 4021, 35),
      ))
    }

@delegate:ResourceContentHash(401_056_728)
internal val Res.string.sso_cancelled: StringResource by lazy {
      StringResource("string:sso_cancelled", "sso_cancelled", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 4665, 65),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 4057, 53),
      ))
    }

@delegate:ResourceContentHash(82_618_304)
internal val Res.string.sso_login: StringResource by lazy {
      StringResource("string:sso_login", "sso_login", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 4731, 21),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 4111, 21),
      ))
    }

@delegate:ResourceContentHash(895_515_491)
internal val Res.string.sso_success: StringResource by lazy {
      StringResource("string:sso_success", "sso_success", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 4753, 55),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 4133, 47),
      ))
    }

@delegate:ResourceContentHash(481_259_579)
internal val Res.string.suggested_homeservers: StringResource by lazy {
      StringResource("string:suggested_homeservers", "suggested_homeservers", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 4809, 65),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 4181, 57),
      ))
    }

@delegate:ResourceContentHash(-1_646_106_512)
internal val Res.string.summary_is_merge: StringResource by lazy {
      StringResource("string:summary_is_merge", "summary_is_merge", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 4875, 120),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 4239, 80),
      ))
    }

@delegate:ResourceContentHash(2_134_673_475)
internal val Res.string.the_other_device: StringResource by lazy {
      StringResource("string:the_other_device", "the_other_device", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 4996, 48),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 4320, 48),
      ))
    }

@delegate:ResourceContentHash(-1_273_979_533)
internal val Res.string.timestamp: StringResource by lazy {
      StringResource("string:timestamp", "timestamp", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 5241, 29),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 4549, 29),
      ))
    }

@delegate:ResourceContentHash(-616_449_564)
internal val Res.string.timestamp_days_ago: StringResource by lazy {
      StringResource("string:timestamp_days_ago", "timestamp_days_ago", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 5045, 46),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 4369, 46),
      ))
    }

@delegate:ResourceContentHash(2_078_472_101)
internal val Res.string.timestamp_hours_ago: StringResource by lazy {
      StringResource("string:timestamp_hours_ago", "timestamp_hours_ago", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 5092, 51),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 4416, 47),
      ))
    }

@delegate:ResourceContentHash(-909_270_774)
internal val Res.string.timestamp_just_now: StringResource by lazy {
      StringResource("string:timestamp_just_now", "timestamp_just_now", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 5144, 42),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 4464, 38),
      ))
    }

@delegate:ResourceContentHash(378_156_254)
internal val Res.string.timestamp_minutes_ago: StringResource by lazy {
      StringResource("string:timestamp_minutes_ago", "timestamp_minutes_ago", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 5187, 53),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 4503, 45),
      ))
    }

@delegate:ResourceContentHash(646_801_920)
internal val Res.string.token_login: StringResource by lazy {
      StringResource("string:token_login", "token_login", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 5271, 27),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 4579, 27),
      ))
    }

@delegate:ResourceContentHash(-686_487_154)
internal val Res.string.total_amount: StringResource by lazy {
      StringResource("string:total_amount", "total_amount", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 5299, 36),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 4607, 36),
      ))
    }

@delegate:ResourceContentHash(594_331_881)
internal val Res.string.transaction_applied: StringResource by lazy {
      StringResource("string:transaction_applied", "transaction_applied", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 5336, 59),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 4644, 55),
      ))
    }

@delegate:ResourceContentHash(2_056_922_174)
internal val Res.string.transaction_details: StringResource by lazy {
      StringResource("string:transaction_details", "transaction_details", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 5396, 55),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 4700, 55),
      ))
    }

@delegate:ResourceContentHash(-520_459_759)
internal val Res.string.transaction_failed: StringResource by lazy {
      StringResource("string:transaction_failed", "transaction_failed", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 5452, 82),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 4756, 62),
      ))
    }

@InternalResourceApi
internal fun _collectCommonMainString0Resources(map: MutableMap<String, StringResource>) {
  map.put("accept", Res.string.accept)
  map.put("accept_all", Res.string.accept_all)
  map.put("access_token", Res.string.access_token)
  map.put("add_topic", Res.string.add_topic)
  map.put("add_transaction", Res.string.add_transaction)
  map.put("amount", Res.string.amount)
  map.put("another_device_accepted_verification", Res.string.another_device_accepted_verification)
  map.put("another_device_requesting_verification", Res.string.another_device_requesting_verification)
  map.put("app_name", Res.string.app_name)
  map.put("avatar", Res.string.avatar)
  map.put("back", Res.string.back)
  map.put("balances", Res.string.balances)
  map.put("cancel", Res.string.cancel)
  map.put("cancel_topic", Res.string.cancel_topic)
  map.put("choose_sso_provider", Res.string.choose_sso_provider)
  map.put("choose_verification_method", Res.string.choose_verification_method)
  map.put("compare", Res.string.compare)
  map.put("compare_emoji_sequence", Res.string.compare_emoji_sequence)
  map.put("confirm", Res.string.confirm)
  map.put("confirm_settle_all", Res.string.confirm_settle_all)
  map.put("continue_button", Res.string.continue_button)
  map.put("debug_hints", Res.string.debug_hints)
  map.put("debug_hints_description", Res.string.debug_hints_description)
  map.put("debug_new_summary", Res.string.debug_new_summary)
  map.put("debug_reset_trust", Res.string.debug_reset_trust)
  map.put("decline", Res.string.decline)
  map.put("delete_template", Res.string.delete_template)
  map.put("description", Res.string.description)
  map.put("deselect", Res.string.deselect)
  map.put("device_offline", Res.string.device_offline)
  map.put("device_verified_successfully", Res.string.device_verified_successfully)
  map.put("entered_by", Res.string.entered_by)
  map.put("error", Res.string.error)
  map.put("failed_create_trust_summary", Res.string.failed_create_trust_summary)
  map.put("failed_prepare_trust_summary", Res.string.failed_prepare_trust_summary)
  map.put("failed_send_message", Res.string.failed_send_message)
  map.put("failed_send_message_with_error", Res.string.failed_send_message_with_error)
  map.put("favorite", Res.string.favorite)
  map.put("favorite_room", Res.string.favorite_room)
  map.put("favorites", Res.string.favorites)
  map.put("flip_balances", Res.string.flip_balances)
  map.put("flip_balances_description", Res.string.flip_balances_description)
  map.put("follow_instructions_other_device", Res.string.follow_instructions_other_device)
  map.put("homeserver_url", Res.string.homeserver_url)
  map.put("invalid_amount", Res.string.invalid_amount)
  map.put("latest_summary_not_trusted", Res.string.latest_summary_not_trusted)
  map.put("lender", Res.string.lender)
  map.put("login", Res.string.login)
  map.put("login_failed", Res.string.login_failed)
  map.put("login_with_sso", Res.string.login_with_sso)
  map.put("logout", Res.string.logout)
  map.put("match", Res.string.match)
  map.put("mismatch", Res.string.mismatch)
  map.put("monetary_unit_warning", Res.string.monetary_unit_warning)
  map.put("more_options", Res.string.more_options)
  map.put("new_transaction", Res.string.new_transaction)
  map.put("no_balances_yet", Res.string.no_balances_yet)
  map.put("no_debts", Res.string.no_debts)
  map.put("no_rooms_available", Res.string.no_rooms_available)
  map.put("no_transactions_yet", Res.string.no_transactions_yet)
  map.put("not_included_in_summary", Res.string.not_included_in_summary)
  map.put("ok", Res.string.ok)
  map.put("override", Res.string.`override`)
  map.put("password", Res.string.password)
  map.put("password_login", Res.string.password_login)
  map.put("payment", Res.string.payment)
  map.put("pick_a_room", Res.string.pick_a_room)
  map.put("recipients", Res.string.recipients)
  map.put("request_full_keyboard", Res.string.request_full_keyboard)
  map.put("request_full_keyboard_description", Res.string.request_full_keyboard_description)
  map.put("room", Res.string.room)
  map.put("room_currency", Res.string.room_currency)
  map.put("room_info", Res.string.room_info)
  map.put("room_protocol_too_new", Res.string.room_protocol_too_new)
  map.put("room_topic", Res.string.room_topic)
  map.put("save", Res.string.save)
  map.put("save_as_template", Res.string.save_as_template)
  map.put("save_topic", Res.string.save_topic)
  map.put("select_all", Res.string.select_all)
  map.put("select_homeserver", Res.string.select_homeserver)
  map.put("settings", Res.string.settings)
  map.put("settle_up", Res.string.settle_up)
  map.put("settle_up_desc", Res.string.settle_up_desc)
  map.put("source_code", Res.string.source_code)
  map.put("sso_cancelled", Res.string.sso_cancelled)
  map.put("sso_login", Res.string.sso_login)
  map.put("sso_success", Res.string.sso_success)
  map.put("suggested_homeservers", Res.string.suggested_homeservers)
  map.put("summary_is_merge", Res.string.summary_is_merge)
  map.put("the_other_device", Res.string.the_other_device)
  map.put("timestamp", Res.string.timestamp)
  map.put("timestamp_days_ago", Res.string.timestamp_days_ago)
  map.put("timestamp_hours_ago", Res.string.timestamp_hours_ago)
  map.put("timestamp_just_now", Res.string.timestamp_just_now)
  map.put("timestamp_minutes_ago", Res.string.timestamp_minutes_ago)
  map.put("token_login", Res.string.token_login)
  map.put("total_amount", Res.string.total_amount)
  map.put("transaction_applied", Res.string.transaction_applied)
  map.put("transaction_details", Res.string.transaction_details)
  map.put("transaction_failed", Res.string.transaction_failed)
}
